/**
 * @generated SignedSource<<9c059d47fc4d275e43d88697d82e6ae4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CreateIssueDialogV2$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CreateIssueV2">;
  readonly " $fragmentType": "CreateIssueDialogV2";
};
export type CreateIssueDialogV2$key = {
  readonly " $data"?: CreateIssueDialogV2$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateIssueDialogV2">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeTemplates"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateIssueDialogV2",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeTemplates",
          "variableName": "includeTemplates"
        }
      ],
      "kind": "FragmentSpread",
      "name": "CreateIssueV2"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "fcf18cdea5e9e58d40debd36254ceea1";

export default node;
